<template>
    <div class="input-box">
        <label class="input-label" :class="labelClass">
            <span class="label">{{ label }}</span>
            <img v-if="icon" :src="$imageUrl(icon + '.svg')" :alt="label" class="icon">
            <input :value="value" @input="$emit('input', Math.abs($event.target.value))"
                   type="number"
                   min="0"
                   @wheel="$event.target.blur()"
                   @focus="$emit('focus', $event)">
            <span class="unit">{{ unit }}</span>
            <slot/>
        </label>
    </div>
</template>

<script>
export default {
    name: "InputBox",
    props: [
        "labelClass",
        "label",
        "value",
        "unit",
        "icon",
    ],
}
</script>

<style scoped>

</style>
